document.addEventListener('DOMContentLoaded', () => {
    const backButton = document.getElementById('CustomBack')
    if (backButton) {
        backButton.addEventListener('click', () => {
            console.log('clicked')
            history.back()
        })
    }

    // Cart count güncelleme fonksiyonu
    function updateCartCount(count) {
        const cartCounts = document.querySelectorAll('[data-cart-count]');
        const cartToggles = document.querySelectorAll('.cart__toggle');
        
        cartCounts.forEach((element) => {
            element.textContent = count;
        });

        cartToggles.forEach((toggle) => {
            toggle.classList.toggle('cart__toggle--has-items', count > 0);
        });
    }

    // Cart API'sini dinle
    const cartObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.target.hasAttribute('data-cart-items-qty')) {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        updateCartCount(cart.item_count);
                    });
            }
        });
    });

    // Cart drawer içindeki qty elementini izle
    const cartQtyElement = document.querySelector('[data-cart-items-qty]');
    if (cartQtyElement) {
        cartObserver.observe(cartQtyElement, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    }

    // Sayfa yüklendiğinde mevcut cart sayısını al
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            updateCartCount(cart.item_count);
        });

    // Form submit olduğunda
    document.addEventListener('submit', (e) => {
        if (e.target.matches('form[action="/cart/add"]')) {
            setTimeout(() => {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        updateCartCount(cart.item_count);
                    });
            }, 500);
        }
    });

    // AJAX istekleri için
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        return originalFetch.apply(this, args).then((response) => {
            if (args[0].includes('/cart/add') || args[0].includes('/cart/change') || args[0].includes('/cart/update')) {
                setTimeout(() => {
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(cart => {
                            updateCartCount(cart.item_count);
                        });
                }, 500);
            }
            return response;
        });
    };
});

// ... existing code ...